import React, { useEffect, useState } from 'react';

const NoSsr = ({ children }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // This code only runs on the client
    setIsClient(true);
  }, []);

  if (!isClient) return null;

  return <>{children}</>;
};

export default NoSsr;
